import { create } from 'zustand';

type DocumentPreviewState = {
  type: 'email';
  data: string;
  title: string;
} | null;

export type DocumentPreviewStore = {
  state: {
    isOpen: boolean;
    info: DocumentPreviewState;
  } | null;
  open: (drawer: Exclude<DocumentPreviewState, null>) => void;
  close: () => void;
};

export const useDocumentPreviewStore = create<DocumentPreviewStore>((set) => ({
  state: null,
  open: (drawer) =>
    set({
      state: {
        isOpen: true,
        info: drawer,
      },
    }),
  close: () =>
    set({
      state: null,
    }),
}));
